var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5311 2.27147C15.5311 2.27147 16.1551 1.6241 15.5312 0.999956C14.9072 0.375817 14.2596 0.999999 14.2596 0.999999L8.26559 6.99408L2.27155 0.999999C2.27155 0.999999 1.58575 0.4144 0.999976 0.99993C0.414206 1.58546 1.00009 2.27147 1.00009 2.27147L6.99413 8.26555L1.00009 14.2596C1.00009 14.2596 0.384059 14.9151 1.00016 15.5312C1.61626 16.1472 2.27155 15.5311 2.27155 15.5311L8.26559 9.53702L14.2596 15.5311C14.2596 15.5311 14.9604 16.102 15.5312 15.5312C16.1019 14.9603 15.5311 14.2596 15.5311 14.2596L9.53705 8.26555L15.5311 2.27147Z",
    fill: "url(#paint0_linear_633_925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_925",
    x1: 1.841,
    y1: 8.53334,
    x2: 16.0785,
    y2: 8.98523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e6ea1ac927e63bcee4b07c36f964939e.svg";
export { ForwardRef as ReactComponent };